import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="leaseLeaseinfo";
export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function queryByDealId(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/queryByDealId/${parameter}`,
    method: 'get',
  })
}

export function updateCurrentLease(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateCurrentLease`,
    method: 'put',
    data:parameter
  })
}

export function selectAll(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectExpireAllPage(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectExpireAllPage`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryExpireLeaseStatistics(parameter) {
  return axios({
    url: `/ws/${moduleName}/queryExpireLeaseStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllByCustomerId(customerId){
  return axios({
    url: `/ws/${moduleName}/selectAllByCustomerId/${customerId}`,
    method: 'get',
  })
}


export function selectOne(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get',
  })
}

export function deleteObj(id){
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'delete',
  })
}

export function updateLeaseInfoStatus(leaseId,vacantStatus){
  return axios({
    url: `/ws/${moduleName}/updateLeaseInfoStatus/${leaseId}/${vacantStatus}`,
    method: 'put',
  })
}

export default {
  insert,
  queryByDealId,
  updateCurrentLease,
  selectAll,
  selectOne,
  deleteObj,
  updateLeaseInfoStatus,
  selectAllByCustomerId,
  selectExpireAllPage,
  queryExpireLeaseStatistics
}